import styled from "styled-components";

export const WorksMainWrapper = styled.div``;
